var map = {
	"./home/ca.json": [
		171,
		14
	],
	"./home/en.json": [
		172,
		13
	],
	"./home/es.json": [
		173,
		12
	],
	"./home/fr.json": [
		174,
		11
	],
	"./home/it.json": [
		175,
		10
	],
	"./init/ca.json": [
		176,
		9
	],
	"./init/en.json": [
		177,
		8
	],
	"./init/es.json": [
		178,
		7
	],
	"./init/fr.json": [
		179,
		6
	],
	"./init/it.json": [
		180,
		5
	],
	"./instructions/ca.json": [
		181,
		4
	],
	"./instructions/en.json": [
		182,
		3
	],
	"./instructions/es.json": [
		183,
		2
	],
	"./instructions/fr.json": [
		184,
		1
	],
	"./instructions/it.json": [
		185,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 140;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locals lazy ^\.\/.*\.json$
// module id = 140
// module chunks = 16